<template>
  <v-col cols="6">
    <v-card class="align-start metrics-card-middle-bottom">
      <v-card-title class="d-flex justify-center font-weight-bold text-decoration-underline">
        Agent Portal Activity
      </v-card-title>
      <v-card-text class="d-flex flex-row justify-space-around align-center metrics-card-text">
        <stats-value :loading="loading" title="Most recent login">
          {{ lastSeenClientUser }}
        </stats-value>
        <stats-value :loading="loading" title="No. of Seats in Use">
          {{ agentActivity.data.seatsUsed }}
        </stats-value>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import {mapState} from "vuex";
import {LoadingState} from "@/store/constants";
import moment from "moment/moment";
import StatsValue from "@/components/HealthScore/StatsValue.vue";

export default {
  name: 'AgentActivity',
  components: {StatsValue},
  computed: {
    ...mapState('healthScoreStore', ['agentActivity']),
    loading() {
      return this.agentActivity.state === LoadingState.LOADING;
    },
    lastSeenClientUser() {
      return this.agentActivity.data.lastSeen !== '' ? moment(this.agentActivity.data.lastSeen).format('YYYY-MM-DD HH:mm') : '';
    }
  }
}
</script>
